// src/feature-module/pages/login/api/portalApi.js

import { apiRequest } from "./client";
import { mockEvents, mockNetworkStats, mockOffers, delay } from "./mockData";
import { JSON_BASE_API_URL } from "../../../../components/config/config";

const USE_MOCK = false; // flip to true to force mock data everywhere

async function withFallback(request, mockValue, mockDelay = 400) {
  if (USE_MOCK) {
    await delay(mockDelay);
    return mockValue;
  }
  try {
    return await request();
  } catch (err) {
    console.error("API request failed, falling back to mock data:", err);
    await delay(mockDelay);
    return mockValue;
  }
}

export const portalApi = {
  // Single combined endpoint — replaces the old getSpotlights/getUpdates/getAnnouncement calls
  getIbizContent: () =>
    withFallback(
      () => fetch(`${JSON_BASE_API_URL}/ibiz-content`).then((r) => r.json()),
      // () =>
      //   fetch(`https://devapi.perennialcode.in/ibiz-content`).then((r) =>
      //     r.json(),
      //   ),
      null,
      400,
    ),

  getEvents: () =>
    withFallback(() => apiRequest("/events/upcoming"), mockEvents, 500),

  getNetworkStats: () =>
    withFallback(
      () => apiRequest("/content/network-stats"),
      mockNetworkStats,
      400,
    ),

  getOffers: () =>
    withFallback(() => apiRequest("/offers/exclusive"), mockOffers, 450),

  login: ({ username, password }) =>
    withFallback(
      () =>
        apiRequest("/auth/login", {
          method: "POST",
          body: { username, password },
          auth: false,
        }),
      { token: "demo-token", user: { name: "Subscriber Admin" } },
      700,
    ),
};
